export * from '@firebase/messaging/sw';
//# sourceMappingURL=index.esm.js.map
